import ModalBasicLayout from "../../../Modal/ModalBasicLayout";
import {
  BUTTON_GO_BACK,
  BUTTON_SAVE,
  BUTTON_SELECT_CONTENT,
  FIELD_MAX_LENGTH,
  FIELD_REQUIRED,
  MODAL_SITE_LINKS_DESCRIPTION,
  MODAL_SITE_LINKS_TITLE,
  MODAL_SITE_LINK_TITLE,
  MODAL_SITE_LINK_URL,
  MODAL_SITE_LINK_IMAGE_URL,
  BUTTON_ADD_SITE_LINK,
  FIELD_URL_VALID,
} from "../../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../../lib/i18next";
import { Controller, useForm, useFieldArray } from "react-hook-form";
import { useEffect } from "react";
import _ from "lodash";
import useFocusErrorForm from "../../../../hooks/useFocusErrorForm";
import Box from "@mui/material/Box";
import TextField from "../../../Form/TextField";
import ContainerModalActions from "../../../Containers/ContainerModalActions";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import IconButton from "@mui/material/IconButton";
import IconButtonAddContent from "../../../Buttons/IconButtonAddContent";
import { useDispatchApp } from "../../../../lib/redux";
import { getPathDatabaseByRole } from "../../../../actions/auth";
import { IMAGE_FORMATS, META } from "../../../../utils/constants";
import Typography from "@mui/material/Typography";
import Button from "../../../Buttons/Button";
import ChipOptional from "../../../Chip/ChipOptional";
import { REGEX_URL } from "../../../../utils/regex";
import CloseIcon from "@mui/icons-material/Close";
import { getUniqueID } from "../../../../utils/numbers";

const ModalSiteLinks = ({
  modalOpen,
  language,
  onCloseModal = () => {},
  onCallbackSave = () => {},
  data = [],
}) => {
  const { control, getValues, formState, handleSubmit, setValue } = useForm({
    defaultValues: {
      siteLinks: [
        {
          imageUrl: "",
          title: "",
          url: "",
        },
      ],
    },
    mode: "onChange",
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "siteLinks",
  });

  useFocusErrorForm(formState);
  const { errors } = formState;
  const { t } = useTranslationApp();
  const dispatch = useDispatchApp();
  const { userID } = dispatch(getPathDatabaseByRole());

  const onSubmit = () => {
    const formValues = getValues();
    onCallbackSave(formValues.siteLinks);
    onCloseModal();
  };

  useEffect(() => {
    if (_.isEmpty(data)) return;
    fields.forEach((_, index) => remove(index));
    data.forEach((item) => append(item));
    // eslint-disable-next-line
  }, []);

  return (
    <ModalBasicLayout
      modalOpen={modalOpen}
      onCloseModal={onCloseModal}
      fullWidth={true}
      scroll="paper"
      maxWidth="md"
      title={t(MODAL_SITE_LINKS_TITLE)}
      description={t(MODAL_SITE_LINKS_DESCRIPTION)}
    >
      <Box
        component="form"
        onSubmit={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleSubmit(onSubmit)();
        }}
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        {fields.length === 0 && (
          <Box>
            <Button
              variant="contained"
              color="primary"
              onClick={() => append({ imageUrl: "", title: "", url: "" })}
            >
              <AddIcon />
              {t(BUTTON_ADD_SITE_LINK)}
            </Button>
          </Box>
        )}
        {fields.length > 0 && (
          <>
            {fields.map((field, index) => {
              const currentImageUrl = field.imageUrl;

              return (
                <Box
                  key={field.id}
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    gap: 1,
                    p: 2,
                    border: "1px solid",
                    borderColor: "divider",
                    borderRadius: 1,
                    position: "relative",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      width: "max-content",
                      alignItems: "flex-start",
                      gap: 1,
                    }}
                  >
                    {currentImageUrl && (
                      <Box
                        sx={{
                          display: "flex",
                          position: "relative",
                        }}
                      >
                        <Box
                          component="img"
                          src={currentImageUrl}
                          alt="thumbnail"
                          sx={{
                            width: 64,
                            height: 64,
                            objectFit: "cover",
                            borderRadius: 1,
                          }}
                        />
                        <IconButton
                          size="small"
                          onClick={() => {
                            const currentValues = getValues();
                            currentValues.siteLinks[index].imageUrl = "";
                            setValue("siteLinks", currentValues.siteLinks);
                          }}
                          sx={{
                            position: "absolute",
                            top: 0,
                            right: 0,
                            p: 0,
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Box>
                    )}
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 0.5,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          gap: 1,
                          alignItems: "center",
                          mb: 0.3,
                        }}
                      >
                        <Typography variant="body2">
                          {t(MODAL_SITE_LINK_IMAGE_URL)}
                        </Typography>
                        <ChipOptional size="small" />
                      </Box>
                      <Controller
                        name={`siteLinks.${index}.imageUrl`}
                        control={control}
                        render={() => (
                          <IconButtonAddContent
                            id={getUniqueID()}
                            mode="button"
                            color="secondary"
                            size="large"
                            minDimensions={{
                              width: 300,
                              height: 300,
                            }}
                            initialValues={{ language, platform: META }}
                            pathStorage={`socialMedia/${userID}`}
                            modeUpload="sync"
                            onAddContent={(contents) => {
                              const url = contents?.[0]?.url;
                              const currentValues = getValues();
                              currentValues.siteLinks[index].imageUrl = url;
                              setValue("siteLinks", currentValues.siteLinks);
                            }}
                            onCallbackSaveCanva={(mediaUrl) => {
                              const currentValues = getValues();
                              currentValues.siteLinks[index].imageUrl =
                                mediaUrl;
                              setValue("siteLinks", currentValues.siteLinks);
                            }}
                            multiple={false}
                            acceptedFormats={IMAGE_FORMATS}
                            showGallerySocialNetworkOption={false}
                            textButton={BUTTON_SELECT_CONTENT}
                            sx={{
                              alignItems: "flex-start",
                              width: { xs: "100%", md: "auto" },
                            }}
                            sxButton={{
                              height: 41,
                              fontSize: "0.875rem",
                              width: "100%",
                            }}
                            propsPostsAdsPlatforms={{}}
                          />
                        )}
                      />
                    </Box>
                  </Box>

                  <TextField
                    label={t(MODAL_SITE_LINK_TITLE)}
                    name={`siteLinks.${index}.title`}
                    variant="filled"
                    fullWidth={false}
                    InputLabelProps={{ shrink: true }}
                    sx={{
                      flexGrow: 1,
                    }}
                    control={control}
                    errors={errors}
                    rules={{
                      required: {
                        value: true,
                        message: t(FIELD_REQUIRED),
                      },
                      maxLength: {
                        value: 30,
                        message: t(FIELD_MAX_LENGTH, { value: 30 }),
                      },
                    }}
                  />

                  <TextField
                    label={t(MODAL_SITE_LINK_URL)}
                    name={`siteLinks.${index}.url`}
                    variant="filled"
                    fullWidth={false}
                    InputLabelProps={{ shrink: true }}
                    sx={{
                      flexGrow: 1,
                    }}
                    control={control}
                    errors={errors}
                    rules={{
                      required: {
                        value: true,
                        message: t(FIELD_REQUIRED),
                      },
                      pattern: {
                        value: REGEX_URL,
                        message: t(FIELD_URL_VALID),
                      },
                    }}
                  />

                  <Box
                    sx={{
                      display: "flex",
                      gap: 1,
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => remove(index)}
                      sx={{ p: 0.4 }}
                    >
                      <DeleteIcon />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() =>
                        append({ imageUrl: "", title: "", url: "" })
                      }
                      sx={{ p: 0.4 }}
                    >
                      <AddIcon />
                    </IconButton>
                  </Box>
                </Box>
              );
            })}
          </>
        )}

        <ContainerModalActions
          sx={{ mt: 1 }}
          hasPadding={false}
          propsSecondaryButton={{
            showButton: true,
            onClick: onCloseModal,
            disabled: false,
            text: BUTTON_GO_BACK,
          }}
          propsPrimaryButton={{
            showButton: true,
            loading: false,
            text: BUTTON_SAVE,
            type: "submit",
            onClick: () => {},
          }}
        />
      </Box>
    </ModalBasicLayout>
  );
};

export default ModalSiteLinks;
